const degrees =[
    {
        university: 'University College London',
        url: 'https://www.ucl.ac.uk/',
        degreeName: ' PhD in Computer Science',
        startDate: 'Sep. 2023',
        endDate: '',
        thesisTitle: 'Enhancing User Exploration and Control over Data in LLM-Based Conversational Agents',
        grade: ''
    },

    {
        university: 'University College London',
        url: 'https://www.ucl.ac.uk/',
        degreeName: 'MSc. in Human-Computer Interaction',
        startDate: 'Sep. 2021',
        endDate: 'Sep. 2022',

    },

    {
        university: 'University of Warwick',
        url: 'https://warwick.ac.uk/',
        degreeName: 'BSc. in Computer Science (1st Class)',
        startDate: 'Oct. 2017',
        endDate: 'Jul. 2020',
    }
]

export default degrees;